if($('.type-category').length){
    document.addEventListener('ShoptetDOMContentLoaded', function() {
        filter();
    });
    document.addEventListener('ShoptetDOMPageContentLoaded', function() {
        filter();
    }); 


    
    

    $(document).ready(function() {
        filter();
    }); 
    
}

function filter() {
    if(!$('.sortProducts').length){
        var sortText = $('#category-header input:checked + label').text().trim();

        // Kontrola, zda text existuje
        if (sortText) {
            // Pokud ano, použijeme tento text
            $('.category-header').append('<div class="sortProducts"><span>' + sortText + '</span></div>');
        } else {
            // Pokud ne, použijeme výchozí text "Seřadit dle"
            $('.category-header').append('<div class="sortProducts"><span>Sortieren nach</span></div>');
        }
    }
  }

  $(document).on('click', '.sortProducts', function() {
    $(this).closest('#category-header').find('form').toggleClass("showSort");
  });